export default function DocsIcon() {
  return (
    <svg
      width="35"
      height="34"
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.700195 5.0002C0.700195 2.34923 2.84923 0.200195 5.5002 0.200195H22.3002C24.9512 0.200195 27.1002 2.34923 27.1002 5.0002V21.8002H34.3002V26.6002C34.3002 30.5766 31.0766 33.8002 27.1002 33.8002H7.9002C3.92375 33.8002 0.700195 30.5766 0.700195 26.6002V5.0002ZM27.1002 24.2002V31.4002C29.7512 31.4002 31.9002 29.2512 31.9002 26.6002V24.2002H27.1002ZM24.7002 31.4002V5.0002C24.7002 3.67471 23.6257 2.6002 22.3002 2.6002H5.5002C4.17471 2.6002 3.1002 3.67471 3.1002 5.0002V26.6002C3.1002 29.2512 5.24923 31.4002 7.9002 31.4002H24.7002ZM7.9002 8.6002C7.9002 7.93745 8.43745 7.4002 9.1002 7.4002H18.7002C19.3629 7.4002 19.9002 7.93745 19.9002 8.6002C19.9002 9.26294 19.3629 9.8002 18.7002 9.8002H9.1002C8.43745 9.8002 7.9002 9.26294 7.9002 8.6002ZM7.9002 15.8002C7.9002 15.1375 8.43745 14.6002 9.1002 14.6002H18.7002C19.3629 14.6002 19.9002 15.1375 19.9002 15.8002C19.9002 16.4629 19.3629 17.0002 18.7002 17.0002H9.1002C8.43745 17.0002 7.9002 16.4629 7.9002 15.8002ZM7.9002 23.0002C7.9002 22.3375 8.43745 21.8002 9.1002 21.8002H13.9002C14.5629 21.8002 15.1002 22.3375 15.1002 23.0002C15.1002 23.6629 14.5629 24.2002 13.9002 24.2002H9.1002C8.43745 24.2002 7.9002 23.6629 7.9002 23.0002Z"
        fill="#6A7282"
      />
    </svg>
  );
}
